// src/config.js
//https://api.rengie.in

//http://localhost:5042
// Yahan bas URL change kariye, puri app me change ho jayega
const BASE_DOMAIN = "https://api.rengie.in"; 

const config = {
 
  API_BASE_URL: `${BASE_DOMAIN}/api`,
  

  IMG_BASE_URL: BASE_DOMAIN,
  
};

export default config;